import ExpensesService from "services/ExpensesService";

const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

export const getExpenses = createAsyncThunk(
  "Expenses/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ExpensesService.getexpenses();
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response || "Erreur");
    }
  }
);

export const getExpenseById = createAsyncThunk(
  "Expenses/getExpenseById",
  async (expenseId, { rejectWithValue }) => {
    try {
      const response = await ExpensesService.getExpenseById(expenseId);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response || "Erreur");
    }
  }
);

export const createExpense = createAsyncThunk(
  "Expenses/createExpense",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ExpensesService.createExpense(data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.error || "Erreur");
    }
  }
);

export const updateExpenseById = createAsyncThunk(
  "Expenses/updateExpenseById",
  async ({ expenseId, data }, { rejectWithValue }) => {
    try {
      const response = await ExpensesService.updateExpense(expenseId, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Erreur");
    }
  }
);

export const deleteExpenseById = createAsyncThunk(
  "Expenses/deleteExpenseById",
  async (id, { rejectWithValue }) => {
    try {
      // TODO: this is supposed to return the deleted expense id, but the API returns only a status message
      const response = await ExpensesService.deleteExpenseById(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response || "Erreur");
    }
  }
);

const initialState = {
  expenses: [],
  expense: null,
  loading: false,
  error: null,
};

const ExpensesSlice = createSlice({
  name: "Expenses",
  initialState,
  reducers: {
    setExpenses: (state, { payload }) => {
      state.expenses = payload;
    },
    setExpense: (state, { payload }) => {
      state.expense = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
  },
  extraReducers: {
    [getExpenses.pending]: (state) => {
      state.loading = true;
    },
    [getExpenses.fulfilled]: (state, { payload }) => {
      state.expenses = payload;
      state.loading = false;
    },
    [getExpenses.rejected]: (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    },
    [getExpenseById.pending]: (state) => {
      state.loading = true;
    },
    [getExpenseById.fulfilled]: (state, { payload }) => {
      state.expense = payload;
      state.loading = false;
    },
    [getExpenseById.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [createExpense.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [createExpense.fulfilled]: (state, { payload }) => {
      state.expenses.push(payload.expenses);
      state.loading = false;
    },
    [createExpense.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [updateExpenseById.pending]: (state) => {
      state.loading = true;
    },
    [updateExpenseById.fulfilled]: (state, { payload }) => {
      state.expenses = state.expenses.map((expense) =>
        expense._id === payload.expenses._id ? payload.expenses : expense
      );
      state.loading = false;
    },
    [updateExpenseById.rejected]: (state, { payload }) => {
      state.loading = false;
    },
    [deleteExpenseById.pending]: (state) => {
      state.loading = true;
    },
    [deleteExpenseById.fulfilled]: (state, { payload }) => {
      state.expenses = state.expenses.filter(
        (expense) => expense._id !== payload
      );
      state.loading = false;
    },
    [deleteExpenseById.rejected]: (state, { payload }) => {
      state.loading = false;
    },
  },
});

export const { setExpenses, setExpense, setLoading, setError } =
  ExpensesSlice.actions;

export default ExpensesSlice.reducer;
